import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  DataList,
  Ticket,
  TicketCategory,
  TicketMessage,
  TicketMessageResponse,
  TicketRegister,
  TicketRegisterResponse,
  TicketMessageRegister,
} from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  constructor(private apiService: ApiService) {}

  categories(): Observable<DataList<TicketCategory>> {
    return this.apiService.get<DataList<TicketCategory>>('user/ticket_categories').pipe();
  }

  register(ticketData: TicketRegister): Observable<TicketRegisterResponse> {
    return this.apiService.post<TicketRegisterResponse>('user/tickets', ticketData).pipe();
  }

  respose(messageData: TicketMessageRegister, id: number): Observable<TicketMessageResponse> {
    return this.apiService.post<TicketMessageResponse>('user/tickets/' + id + '/messages', messageData).pipe();
  }

  list(): Observable<DataList<Ticket>> {
    return this.apiService.get<DataList<Ticket>>('user/tickets').pipe();
  }

  show(id: number): Observable<Ticket> {
    return this.apiService.get<Ticket>('user/tickets/' + id).pipe();
  }

  messages(id: number): Observable<DataList<TicketMessage>> {
    return this.apiService.get<DataList<TicketMessage>>('user/tickets/' + id + '/messages').pipe();
  }
}
